__webpack_require__.p = "/sttc/nx/web-platform/banana/";